import { useContext, useEffect, useState } from "react";
import Apicall from "../api/Apicall";
import { Context } from "../components/containers/context/Context";

export const useSummaries = () => {

  const { app, dataServicios, user } = useContext(Context);

  const [dataRequisiciones, setDataRequisiciones] = useState(null);
  const [dataRequestsQuotation, setDataRequestsQuotation] = useState(null);
  const [dataRegistroProveedores, setDataRegistroProveedores] = useState(null);
  const [dataGridConcentOportunidades, setDataGridConcentOportunidades] = useState(null);
  const [dataContratos, setDataContratos] = useState(null);

  const [dataCertificados, setDataCertificados] = useState(null);
  const [dataGridCertificadosActual, setDataGridCertificadosActual] = useState(null);
  const [dataGridCertificadosPasado, setDataGridCertificadosPasado] = useState(null);

  const [dataOrdenesCompra, setDataOrdenesCompra] = useState(null);
  const [dataEntradas, setDataEntradas] = useState(null);
  const [dataGridConcentNonconformities, setDataGridConcentNonconformities] = useState(null);
  const [dataEvaluaciones, setDataEvaluaciones] = useState(null);

  const [dataFacturasPagos, setDataFacturasPagos] = useState(null);
  const [dataVencimientos, setDataVencimientos] = useState(null);
  const [dataGridConcentVencimientos, setDataGridConcentVencimientos] = useState(null);
  const [dataFinanciamientoProveedores, setDataFinanciamientoProveedores] = useState(null);
  const [dataGridConcentFinProveedores, setDataGridConcentFinProveedores] = useState(null);

  const [dataCaptiva, setDataCaptiva] = useState(null);
  const [dataCarteraMorosa, setDataCarteraMorosa] = useState(null);
  const [dataGridConcentColateral, setDataGridConcentColateral] = useState(null);
  const [dataGridPaymentsPortfolio, setDataGridPaymentsPortfolio] = useState(null);

  const [arrayDataSourcing, setArrayDataSourcing] = useState({ dataRegistroProveedores, dataRequisiciones, dataGridConcentOportunidades, dataContratos });
  const [arrayDataTaxes, setArrayDataTaxes] = useState({ dataCertificados, dataGridCertificadosActual, dataGridCertificadosPasado });
  const [arrayDataProcurement, setArrayDataProcurement] = useState({ dataOrdenesCompra, dataEntradas, dataGridConcentNonconformities, dataEvaluaciones });
  const [arrayDataFinancing, setArrayDataFinancing] = useState({ dataFacturasPagos, dataVencimientos, dataGridConcentVencimientos });
  const [arrayDataCollection, setArrayDataCollection] = useState({ dataCaptiva, dataCarteraMorosa, dataGridConcentColateral, dataGridPaymentsPortfolio });

  const summariesResult = async () => {

    try {

      const serviciosActivos = dataServicios.length > 0
        ? dataServicios
        : [];

      if (serviciosActivos) {
        serviciosActivos.forEach(obj => {
          switch (obj.idServicio) {
            case 1:
              getSummarieFacturasPagos();
              getSummarieVencimientos();
              getGridConcentVencimientos();
              break;
            case 9:
              getSummarieCertificados();
              getGridCertificadosActual();
              getGridCertificadosPasado();
              break;
            case 10:
              getSummarieOrdenesCompra();
              break;
            case 28:
              getSummarieRequisiciones();
              getGridConcentOportunidades();
              break;
            case 64:
              getSummarieEvaluaciones();
              break;
            case 101:
              getSummarieEntradas();
              break;
            case 103:
              getGridConcentNonconformities();
              break;
            case 104:
              getSummarieContratos();
              break;
            case 507:
              getSummarieCaptiva();
              getSummarieCarteraMorosa();
              getGridConcentColateral();
              break;
            case 505:
              getGridPaymentsPortfolio();
              break;
            case 1515:
              getSummarieRegistroProveedores();
              break;
            case 2020:
              getSummarieFinanciamientoProveedores();
              getGridConcentFinProveedores();
              break;
            case 20:
              getSummarieFinanciamientoProveedores();
              getGridConcentFinProveedores();
              break;
            case 102:
              getRFQsummary();
              break;
            default:
              break;
          }
        });

      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  //inicio Sourcing
  async function getSummarieRequisiciones() {
    const result = await Apicall({
      url: `${app.url}/sourcing/getSummarieRequisiciones`, user, app
    });
    setDataRequisiciones(result.data);
  }

  async function getRFQsummary() {
    const result = await Apicall({
      url: `${app.url}/sourcing/getRFQsummary`, user, app
    });
    setDataRequestsQuotation(result.data);
  }

  async function getSummarieRegistroProveedores() {
    const result = await Apicall({
      url: `${app.url}/sourcing/getSummarieRegistroProveedores`, user, app
    });
    setDataRegistroProveedores(result.data);
  }

  async function getGridConcentOportunidades() {
    const result = await Apicall({
      url: `${app.url}/sourcing/getGridConcentOportunidades`, user, app
    });
    setDataGridConcentOportunidades(result.data);
  }

  async function getSummarieContratos() {
    const result = await Apicall({
      url: `${app.url}/sourcing/getSummarieContratos`, user, app
    });
    setDataContratos(result.data);
  }
  //fin Sourcing

  //Inicio Taxes
  async function getSummarieCertificados() {
    const result = await Apicall({
      url: `${app.url}/taxes/getSummarieCertificados`, user, app
    });
    setDataCertificados(result.data);
  }

  async function getGridCertificadosActual() {
    const result = await Apicall({
      url: `${app.url}/taxes/getGridCertificadosActual`, user, app
    });
    setDataGridCertificadosActual(result.data);
  }

  async function getGridCertificadosPasado() {
    const result = await Apicall({
      url: `${app.url}/taxes/getGridCertificadosPasado`, user, app
    });
    setDataGridCertificadosPasado(result.data);
  }

  //Fin Taxes

  //inicio Procurement
  async function getSummarieOrdenesCompra() {
    const result = await Apicall({
      url: `${app.url}/procurement/getSummarieOrdenesCompra`, user, app
    });
    setDataOrdenesCompra(result.data);
  }

  async function getSummarieEntradas() {
    const result = await Apicall({
      url: `${app.url}/procurement/getSummarieEntradas`, user, app
    });
    setDataEntradas(result.data);
  }

  async function getGridConcentNonconformities() {
    const result = await Apicall({
      url: `${app.url}/procurement/getGridConcentNonconformities`, user, app
    });
    setDataGridConcentNonconformities(result.data);
  }

  async function getSummarieEvaluaciones() {
    const result = await Apicall({
      url: `${app.url}/procurement/getSummarieEvaluaciones`, user, app
    });
    setDataEvaluaciones(result.data);
  }

  //fin Procurement

  //Inicio Financing

  async function getSummarieFacturasPagos() {
    const result = await Apicall({
      url: `${app.url}/financing/getSummarieFacturasPagos`, user, app
    });
    setDataFacturasPagos(result.data);
  }

  async function getSummarieVencimientos() {
    const result = await Apicall({
      url: `${app.url}/financing/getSummarieVencimientos`, user, app
    });
    setDataVencimientos(result.data);
  }

  async function getGridConcentVencimientos() {
    const result = await Apicall({
      url: `${app.url}/financing/getGridConcentVencimientos`, user, app
    });
    setDataGridConcentVencimientos(result.data);
  }

  async function getSummarieFinanciamientoProveedores() {
    const result = await Apicall({
      url: `${app.url}/financing/getSummarieFinanciamientoProveedores`, user, app
    });
    setDataFinanciamientoProveedores(result.data);
  }

  async function getGridConcentFinProveedores() {
    const result = await Apicall({
      url: `${app.url}/financing/getGridConcentFinProveedores`, user, app
    });
    setDataGridConcentFinProveedores(result.data);
  }

  //Fin Financing

  //Inicio Collection

  async function getSummarieCaptiva() {
    const result = await Apicall({
      url: `${app.url}/collection/getSummarieCaptiva`, user, app
    });
    setDataCaptiva(result.data);
  }

  async function getSummarieCarteraMorosa() {
    const result = await Apicall({
      url: `${app.url}/collection/getSummarieCarteraMorosa`, user, app
    });
    setDataCarteraMorosa(result.data);
  }

  async function getGridConcentColateral() {
    const result = await Apicall({
      url: `${app.url}/collection/getGridConcentColateral`, user, app
    });
    setDataGridConcentColateral(result.data);
  }

  async function getGridPaymentsPortfolio() {
    const result = await Apicall({
      url: `${app.url}/collection/getGridPaymentsPortfolio`, user, app
    });
    setDataGridPaymentsPortfolio(result.data);
  }

  useEffect(() => {
    if (dataServicios != null) {
      summariesResult();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataServicios]);

  useEffect(() => {
    setArrayDataSourcing({dataRegistroProveedores, dataRequisiciones, dataRequestsQuotation, dataGridConcentOportunidades, dataContratos});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRegistroProveedores, dataRequisiciones, dataRequestsQuotation, dataGridConcentOportunidades, dataContratos]);

  useEffect(() => {
    setArrayDataTaxes({dataCertificados, dataGridCertificadosActual, dataGridCertificadosPasado});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCertificados, dataGridCertificadosActual, dataGridCertificadosPasado]);

  useEffect(() => {
    setArrayDataProcurement({dataOrdenesCompra, dataEntradas, dataGridConcentNonconformities, dataEvaluaciones});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataOrdenesCompra, dataEntradas, dataGridConcentNonconformities, dataEvaluaciones]);

  useEffect(() => {
    setArrayDataFinancing({dataFacturasPagos, dataVencimientos, dataGridConcentVencimientos, dataFinanciamientoProveedores, dataGridConcentFinProveedores});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFacturasPagos, dataVencimientos, dataGridConcentVencimientos, dataFinanciamientoProveedores, dataGridConcentFinProveedores]);

  useEffect(() => {
    setArrayDataCollection({dataCaptiva, dataCarteraMorosa, dataGridConcentColateral, dataGridPaymentsPortfolio});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCaptiva, dataCarteraMorosa, dataGridConcentColateral, dataGridPaymentsPortfolio]);

  //Fin Collection
  /*
      const arrayDataSourcing = {dataRegistroProveedores, dataRequisiciones, dataGridConcentOportunidades, dataContratos}
      const arrayDataProcurement = {dataOrdenesCompra, dataEntradas, dataGridConcentNonconformities, dataEvaluaciones}
      const arrayDataFinancing = {dataFacturasPagos, dataVencimientos, dataGridConcentVencimientos}
      const arrayDataCollection = {dataCaptiva, dataCarteraMorosa, dataGridConcentColateral}
  */
  return { arrayDataSourcing, arrayDataTaxes, arrayDataProcurement, arrayDataFinancing, arrayDataCollection }


}